var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start-page",on:{"click":_vm.goHome}},[_c('img',{staticClass:"bg-img pc-img",attrs:{"src":require("@/assets/start-pc.jpg")}}),_c('img',{staticClass:"bg-img mobile-img",attrs:{"src":require("@/assets/start-mobile.jpg")}}),_c('div',{staticClass:"copyright"},[_vm._v(" Copyright ©湖北省人才发展集团有限公司. All Rights Reserved ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }